import { PolyUtil } from "node-geometry-library"

import type { Location } from "@be-miniapp/types"

function calculateDistanceFromTwoPoints(src: Location, dst: Location) {
  var lat1 = src.latitude
  var lon1 = src.longitude
  var lat2 = dst.latitude
  var lon2 = dst.longitude

  var R = 6378.137 // Radius of earth in KM
  var dLat = (lat2 * Math.PI) / 180 - (lat1 * Math.PI) / 180
  var dLon = (lon2 * Math.PI) / 180 - (lon1 * Math.PI) / 180
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2)
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  var d = R * c
  return d * 1000 // meters
}

function decodePath(path: string): { lat: number; lng: number }[] {
  const pathArray = PolyUtil.decode(path)
  return pathArray
}

export { calculateDistanceFromTwoPoints, decodePath }
